import { ResponseError } from "../errors.js";
export async function generateNonce({ origin }) {
    const response = await fetch(`${origin}/nonce`, {
        method: 'POST',
    });
    if (!response.ok) {
        throw new ResponseError({ status: response.status });
    }
    return await response.json();
}
